import { RefObject, createContext } from 'react';
import { EmployeeTemplateOptionModel } from '../../../../../models/EmployeeTemplateOptionModel';

export const DragContext = createContext<
  [
    null | {
      element: RefObject<HTMLElement | null>;
      data: EmployeeTemplateOptionModel;
      saveOptionNewName: (optionId: number, optionName: string) => void;
      removeOption: (option: EmployeeTemplateOptionModel) => void;
    },
    Function,
  ]
>([null, () => {}]);

export const DropContext = createContext<
  [
    null | {
      element: RefObject<HTMLElement | null>;
      data: EmployeeTemplateOptionModel;
      saveOptionNewName: (optionId: number, optionName: string) => void;
      removeOption: (option: EmployeeTemplateOptionModel) => void;
    },
    Function,
  ]
>([null, () => {}]);

export const DirectionContext = createContext<['before' | 'after', Function]>([
  'before',
  () => {},
]);
